// extracted by mini-css-extract-plugin
export default {"jobList":"styles_jobList__LisHC","job":"styles_job__kbcpa","jobTag":"styles_jobTag__1XyGS","noData":"styles_noData__CtMIh"};